<template>
    <!-- <loading v-if="loading"></loading> -->
    <div class="categoryList-i1">
         <!-- 分类 -->
        <div class="categoryList">
            <div class="categoryList-item" :style="{color:active == index ? '#3D7EFF ':'#1E2134'}" v-for="(item,index) in categoryList" :key="index" @click="clickTab(index)">{{item.title}}</div>
        </div>
        <!-- 论坛 -->
        <div class="forum" v-loading="loading">
            <!-- 论坛列表 -->
            <forumItem v-for="(item,index) in list" :item="item" :key="index" @postLike="postLike" @collect="collect" @goDetails="goDetails"></forumItem>
        </div>
        <noData v-if="noData && !loading"></noData>
        <p v-if="noMore && !noData">已经到底了~</p>
        <!-- 返回顶部 -->
        <img class="backTop" v-if="btnFlag && !noData" @click="backTop" src="../../assets/image/backTop.png" alt="">
    </div>
</template>
<script>
import forumItem from '@/components/forum-item/index.vue'
import request from "@/utils/request";
import {diffTime} from '../../utils/common.js';
import loading from '@/components/loading/loading.vue'
import noData from '@/components/noData/index.vue'
export default {
    components: {forumItem,loading,noData},
    data(){
        return{
            noMore:false,
            loading:true,
            active:0,
            btnFlag:false,//返回顶部
            categoryList:[
                {
                    title:'默认'
                },
                {
                    title:'关注'
                },
                {
                    title:'热榜'
                },
            ],
            list:[],
            date:new Date().toString(),
            content: '',
            // type:3,
            noData:false,
            query:{
                page:1,
                limit:10,
                type:3,
                // user_id:''
            },
        }
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
        window.addEventListener('scroll', this.handleScroll1);  // 监听（绑定）滚轮滚动事件
        this.getList()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll1);   //  离开页面清除（移除）滚轮滚动事件
    },
    created(){
        // this.getList()
    },
    methods:{
        handleScroll1() {
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
               //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
                if(!this.noMore){
                    console.log('触底')
                    this.query.limit += 10
                    this.getList()
                }
                //写后台加载数据的函数
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            }          
        },
        // 帖子点赞
        postLike(id) {
            request({
                url: "/api/userend/post/postLike",
                method: "post",
                params: {forum_post_id:id}
            }).then(response => {
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_like=!this.list[index].is_like
                if(this.list[index].is_like==0){
                    this.list[index].like_num-=1
                }else{
                    this.list[index].like_num+=1
                }
            });
        },
         // 帖子收藏
        collect(id) {
            request({
                url: "/api/userend/post/collect",
                method: "post",
                params: {id:id}
            }).then(response => {
                // this.$message.success("帖子收藏成功")
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_collect=!this.list[index].is_collect
                this.$parent.info()
            });
        },
        getList() {
            this.loading=true
            request({
                url: "/api/userend/post/postList",
                method: "get",
                params: this.query
            }).then(response => {
                response.data.forEach((item,index) => {
                    item.dateTime=diffTime(item.created_at)
                });
                this.list = response.data;
                if(this.list.length < this.query.limit){
                    this.noMore=true
                }
                this.loading=false
                this.noData=response.data.length==0;
            });
        },
        goDetails(id){
            this.$router.push({
                path:"/forum/forumDetails",
                query:{
                    forum_post_id:id
                }
            })
        },
        clickTab(index){
            this.active=index;
            if(index==0){
                this.query.type=3
            }else if(index==1){
                this.query.type=2
            }else{
                this.query.type=1
            }
            this.getList()
        },
        backTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                clearInterval(timer)
                }
            }, 16)
        },
        
        // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
            that.btnFlag = true
            } else {
            that.btnFlag = false
            }
        }
    }
}
</script>
<style lang="scss">
.categoryList-i1{
    padding: 20px 30px;
    .el-loading-spinner{
        position: fixed;
        top: 350px;
        right: 200px;
    }
    .backTop{
        width: 43px;
        height: 43px;
        position: fixed;
        bottom: 60px;
        right: 28%;
    }
    .categoryList{
        // position: fixed;
        background: #FFFFFF;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-bottom: 1px solid #F9FAFD;
        .categoryList-item{
            cursor: pointer;
            padding-bottom: 20px;
            margin-right: 50px;
        }
    }
    p{
        text-align: center;
        padding: 5px 0 15px 15px;
    }
}
</style>